module.exports = __webpack_public_path__ + "data/locale-en.json";


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/locale-en.json
 ** module id = 541
 ** module chunks = 1
 **/